import React from "react";
//Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
import SuccessAnimation from "@limitless/modern/components/success-animation/SuccessAnimation";
import { useExpertProfileContext } from "../../../../../expert";
import { useAppConfig } from "@limitless/common/hooks";
import { useLoginWrapperContext } from "../../../../../expert";
import { useSignInContext } from "@limitless/expert";
import { useAuthenticationContext } from "@limitless/expert";
import MfaPhoneInput from "./mfa-components/MfaPhoneInput";
import { POLICY_MFA_REQUIRED } from "@limitless/portal";
import MfaVerificationCodeInput from "./mfa-components/MfaVerificationCodeInput";
import { refreshToken } from "@limitless/expert/apis/authentication-api/AuthenticationAPI";
import { MFASetupContextProvider } from "../../../../hooks/mfa-setup/MFASetupContext";
import { getInitialMfaState } from "../../../../hooks/mfa-setup/MFAVerifyHook";
import { SUCCESS_ANIMATION_TIMEOUT } from "./ProfileDetails";
const Security = () => {
  const {
    profile,
    canUserAccess,
    loadExpertProfile
  } = useExpertProfileContext();
  const {
    config: {
      dialCodes
    }
  } = useAppConfig();
  const {
    mfaLoginState
  } = useLoginWrapperContext();
  const {
    postAuthenticationActions
  } = useSignInContext();
  const {
    setUserAsAuthenticated
  } = useAuthenticationContext();
  const [mfaState, setMfaState] = React.useState(getInitialMfaState(dialCodes, profile, "submitPhoneScreen", mfaLoginState));
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [showAnimation, setShowAnimation] = React.useState(true);
  React.useEffect(() => {
    var _profile$_phoneDetail;
    setMfaState({
      ...mfaState,
      phoneNumber: (_profile$_phoneDetail = profile === null || profile === void 0 ? void 0 : profile._phoneDetails.phoneNumber) !== null && _profile$_phoneDetail !== void 0 ? _profile$_phoneDetail : mfaState.phoneNumber
    });
  }, [profile === null || profile === void 0 ? void 0 : profile._phoneDetails.phoneNumber]);
  const isEditMobileNoAccess = React.useMemo(() => {
    return canUserAccess(POLICY_MFA_REQUIRED);
  }, [profile]);
  React.useEffect(() => {
    if (isSuccess) {
      setShowAnimation(false);
    } else {
      setShowAnimation(true);
    }
  }, [isSuccess]);
  React.useEffect(() => {
    async function fetchRefreshDetails() {
      await refreshToken().then(data => {
        postAuthenticationActions(data.idToken);
        setUserAsAuthenticated();
      });
    }
    fetchRefreshDetails();
  }, []);
  const renderMfaChildComponents = React.useMemo(() => {
    return isSuccess ? /*#__PURE__*/React.createElement(SuccessAnimation, null) : mfaState.submitPhoneScreen ? /*#__PURE__*/React.createElement(MfaPhoneInput, {
      mfaState: mfaState,
      setMfaState: setMfaState,
      setIsSuccess: setIsSuccess,
      isEditMobileNoAccess: isEditMobileNoAccess
    }) : /*#__PURE__*/React.createElement(MfaVerificationCodeInput, {
      mfaState: mfaState,
      successCB: () => {
        if (mfaState.mfaStepIndex === 1) {
          setIsSuccess(true);
          setTimeout(() => setIsSuccess(false), SUCCESS_ANIMATION_TIMEOUT);
          setMfaState({
            ...mfaState,
            submitPhoneScreen: true,
            mfaStepIndex: mfaState.mfaStepIndex + 1
          });
        } else {
          setMfaState(getInitialMfaState(dialCodes, profile, "submitPhoneScreen", mfaLoginState));
          setIsSuccess(true);
          setTimeout(() => setIsSuccess(false), SUCCESS_ANIMATION_TIMEOUT);
          setMfaState({
            ...mfaState,
            submitPhoneScreen: true,
            editPhoneScreen: true,
            isEmailVerifyed: false,
            mfaStepIndex: mfaState.mfaStepIndex >= 2 ? 1 : mfaState.mfaStepIndex + 1
          });
        }
      },
      setMfaState: setMfaState
    });
  }, [mfaState, isSuccess, isEditMobileNoAccess, mfaState.submitPhoneScreen]);
  return /*#__PURE__*/React.createElement(MFASetupContextProvider, null, /*#__PURE__*/React.createElement(Grid, {
    mt: theme => theme.spacing(3)
  }, /*#__PURE__*/React.createElement(Grid, {
    sx: {
      maxWidth: 470
    },
    display: "flex",
    flexDirection: "column"
  }, !mfaState.editPhoneScreen && /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.grey[4]
    },
    pb: mfaState.submitPhoneScreen || !mfaState.isEmailVerifyed ? 3 : 0
  }, !mfaState.isEmailVerifyed ? "In order to change your phone number, you must first verify your email address." : mfaState.submitPhoneScreen && "Your email address has been verified.")), /*#__PURE__*/React.createElement(Grid, null, renderMfaChildComponents)));
};
export default Security;